import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RefreshLinkIcon = ({ ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent
    title="Refresh"
    width={26}
    height={24}
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* prettier-ignore */}
    <rect x="1" width="24" height="24" fill="#D8D8D8" fillOpacity="0.01" />
    <path
      d="M6.19872 15.3462C4.75156 14.051 3.84082 12.1687 3.84082 10.0737C3.84082 6.167 7.00782 3 10.9145 3C12.0837 3 13.1867 3.28368 14.1584 3.78597"
      stroke="#0075AE"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M2.48755 15.6055L7.01385 16.9289L8.33723 12.4026"
      stroke="#0075AE"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.2066 8.37645C21.6537 9.67169 22.5645 11.554 22.5645 13.649C22.5645 17.5557 19.3975 20.7227 15.4908 20.7227C14.3215 20.7227 13.2186 20.439 12.2469 19.9367"
      stroke="#0075AE"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M23.9177 8.11719L19.3914 6.7938L18.068 11.3201"
      stroke="#0075AE"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </CreateIconComponent>
);

export default RefreshLinkIcon;
